import React, { Fragment } from 'react'

import { range } from 'lodash'
import styled from 'styled-components'

const completedColor = 'var(--color-secondary-800)'
const incompletedColor = 'var(--color-secondary-200)'

const StepContainer = styled.div`
  grid-area: stepIndicator;
  display: flex;
  align-items: center;
  position: relative;
`

interface StepBarProps {
  number: number
  currentStep: number
}

const StepBar = styled.div.attrs((props: StepBarProps) => ({
  number: props.number,
  currentStep: props.currentStep,
}))<StepBarProps>`
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    width: 21%;
    transform: translateY(-50%);
    transform: translateX(-30%);
    height: 2px;
    background: ${incompletedColor};
    ${({ number, currentStep }) =>
      number < currentStep + 1 &&
      `
        background: ${completedColor};
    `}
    z-index: 1;
  }
`

interface StepCircleProps {
  number: number
  currentStep: number
}

const StepCircle = styled.span.attrs((props: StepCircleProps) => ({
  number: props.number,
  currentStep: props.currentStep,
}))<StepCircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 25px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: ${incompletedColor};
  border: 2px solid ${incompletedColor};
  box-sizing: border-box;
  ${({ number, currentStep }) =>
    number < currentStep + 1 &&
    `
      border: 2px solid ${completedColor};
      color: ${completedColor};
  `}
  ${({ number, currentStep }) =>
    number === currentStep + 1 &&
    `
      border: 2px solid ${completedColor};
      background: ${completedColor};
      color: white;
  `}
  margin-right: 10px;
  font-weight: bold;
  z-index: 2;
`

interface StepsProps {
  currentStepIndex: number
  totalSteps?: number
  className?: string
}

const Steps: React.FC<StepsProps> = ({
  currentStepIndex = 0,
  totalSteps = 3,
  className,
}) => (
  <StepContainer className={className}>
    {/* creates an array [1, 2, 3]  */}
    {range(1, totalSteps + 1).map((step) => (
      <Fragment key={`step-indicator-${step}`}>
        <StepCircle number={step} currentStep={currentStepIndex}>
          {step}
        </StepCircle>
        {step < totalSteps && (
          <StepBar number={step} currentStep={currentStepIndex} />
        )}
      </Fragment>
    ))}
  </StepContainer>
)

export default Steps
